const selectClientSecret = state => state.payments.client_secret;
const selectInvoiceID = state => state.payments.invoice_id;

export default {selectClientSecret, selectInvoiceID};